export default {
  apiKey: 'AIzaSyAj6LRLwYocWfpDkMmB8mTA_76xuW8PJi0',
  authDomain: 'ngapp5-staging.firebaseapp.com',
  databaseURL: 'https://ngapp5-staging.firebaseio.com',
  projectId: 'ngapp5-staging',
  storageBucket: 'ngapp5-staging.appspot.com',
  messagingSenderId: '623825793729',
  appId: '1:623825793729:web:e19c3671cac417aa4e9a40',
  reCaptchaKey: '6Lej6DclAAAAAE1KMnMXlGwYWJis79MkhJu_cgH-'
}
